export enum ContentTypes {
  TEST = 'AdvizedTest',
  TOPLIST = 'AdvizedToplist',
  TOPLIST_HEADLINE = 'ToplistHeadline',
  GUIDE = 'ExpertGuide',
}
